/** @jsxImportSource @emotion/react */
import { FunctionComponent } from 'react';
import { css } from '@emotion/react';
import { hooks as commonHooks, types as commonTypes } from '@sitebuilder/common';
import {
    getTextSchemaProperties,
    getStyleSchemaProperties,
    getLayoutSchemaProperties,
} from '../utils';
import htmlBlockStyles, { themeHtmlBlockStyles } from './htmlBlock.style';

const HtmlBlockTemplateView: FunctionComponent<
    React.PropsWithChildren<commonTypes.WidgetInstanceProps | commonTypes.WidgetInstanceProps>
> = (props: commonTypes.WidgetInstanceProps | commonTypes.WidgetInstanceProps) => {
    const widgetInstance = commonHooks.useWidgetInstance(props.widgetInstanceId);

    const { data } = props;
    const i18n = commonHooks.useLocalization();

    const editorHtml = (widgetInstance?.properties.editorHtml as string) || '';
    const classnames = (widgetInstance?.properties.classnames as string) || '';

    const source = editorHtml;
    const boundHtml = i18n.format(source, data);
    const theme = data?.themeSelected || (props as commonTypes.WidgetInstanceProps).theme;

    return (
        <div>
            {/* <code>{JSON.stringify({ data }, null, 2)}</code> */}
            <div
                css={css`
                    ${!theme ? htmlBlockStyles : themeHtmlBlockStyles}
                    ${getTextSchemaProperties(
                        widgetInstance.properties,
                        data?.colorSpace
                    )}${getStyleSchemaProperties(
                        widgetInstance.properties
                    )}${getLayoutSchemaProperties(widgetInstance.properties)}
                `}
                dangerouslySetInnerHTML={{ __html: boundHtml }}
                className={`${classnames} ${
                    widgetInstance?.properties?.typographyClass
                        ? widgetInstance?.properties.typographyClass
                        : ''
                }`}
                data-testid="html-block"
            />
        </div>
    );
};

export default HtmlBlockTemplateView;
